module.exports = __webpack_public_path__ + "img/back-to-top.2290acd0.svg";